module.exports = __webpack_public_path__ + "static/media/vip_big.dc2745a7.png";